/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NotificationChannel = {
    Calendar: 'calendar',
    Chat: 'chat',
    Community: 'communities',
    Feedback: 'feedback',
    Knowledgebase: 'knowledgebase',
    Meeting: 'meeting',
    News: 'news',
    User: 'user'
} as const;
export type NotificationChannel = typeof NotificationChannel[keyof typeof NotificationChannel];

